<template>
  <div>
    <Pane v-if="!hasExtra"/>
    <div class="container">
      <a-form
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
          :colon="false"
          @submit="handleSubmit"
          :form="form"
      >
        <div style="display: flex; justify-content: center; margin-bottom: 16px">
          <a-alert
              v-if="hasAssets"
              message="您名下还有未移交的固定资产，请先完成资产移交后再提交离职申请。"
              type="error"
              show-icon
              style="max-width: 500px"
          />
        </div>
        <a-row>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="申请人">
              <a-input :value="applicant.name" disabled/>
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="申请部门">
              <a-select
                  show-search
                  :filter-option="$selectFilterOption"
                  style="width: 100%"
                  placeholder="根据申请人自动获取"
                  disabled
                  v-decorator="[
                  'applyDeptId',
                  { rules: [{ required: false }] },
                ]"
              >
                <a-select-option
                    v-for="item in organizationList"
                    :key="item.id"
                    :value="item.id"
                >{{ item.uniqueName }}
                </a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="岗位或职务">
              <a-input
                  v-decorator="['position']"
                  placeholder="根据申请人自动获取"
                  disabled
              />
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="参加工作时间">
              <a-date-picker
                  v-decorator="[
                  'workStartDate',
                  { rules: [{ required: false }] },
                ]"
                  placeholder="根据申请人自动获取"
                  disabled
                  style="width: 100%"
              />
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="合同开始时间">
              <a-date-picker
                  v-decorator="[
                  'contractStartDate',
                  { rules: [{ required: false }] },
                ]"
                  placeholder="根据申请人自动获取"
                  disabled
                  style="width: 100%"
              />
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="合同结束时间">
              <a-date-picker
                  v-decorator="[
                  'contractEndDate',
                  { rules: [{ required: false }] },
                ]"
                  placeholder="根据申请人自动获取"
                  disabled
                  style="width: 100%"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="入职日期">
              <a-date-picker
                  v-decorator="[
                  'entryDate',
                  { rules: [{ required: false }] },
                ]"
                  placeholder="根据申请人自动获取"
                  disabled
                  style="width: 100%"
              />
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="离职日期">
              <a-date-picker
                  v-decorator="[
                  'leaveDate',
                  { rules: [{ required: true, message: '请选择离职日期！' }] },
                ]"
                  placeholder="请选择离职日期"
                  style="width: 100%"
              />
            </a-form-item>
          </a-col>

          <a-col :lg="24" :md="24" :sm="24">
            <a-form-item label="离职原因" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
              <a-textarea
                  v-decorator="[
                  'leaveReason',
                  { rules: [{ required: false }] },
                ]"
                  placeholder="请输入离职原因"
                  :rows="4"
              />
            </a-form-item>
          </a-col>

          <a-col :lg="24" :md="24" :sm="24">
            <a-form-item label="附件" :required="true" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
              <a-space style="margin-bottom: 8px">
                <FileUpload @uploaded="onFileUploaded" moduleName="leave">
                  <a-button type="primary" :disabled="fileList.length >= 5">立即上传</a-button>
                </FileUpload>
                <a @click="downloadTemplate" style="margin-left: 8px; cursor: pointer">模板下载</a>
              </a-space>
              <div class="tip-text">请上传离职相关资料，最多上传5个文件</div>
              <div style="background-color: #fff; margin-top: 4px" v-if="fileList.length > 0">
                <a-table bordered :data-source="fileList" :pagination="false" rowKey="id" size="small">
                  <a-table-column title="文件名称">
                    <template slot-scope="text">
                      <a :href="text.completePath || text.url" target="_blank">{{ text.name || text.fileName }}</a>
                    </template>
                  </a-table-column>
                  <a-table-column title="操作" width="80px" align="center">
                    <template slot-scope="text, record, index">
                      <a @click="deleteFile(index)">删除</a>
                    </template>
                  </a-table-column>
                </a-table>
              </div>
            </a-form-item>
          </a-col>
        </a-row>

        <div class="center">
          <a-space>
            <a-button type="primary" html-type="submit" :loading="loading">{{
                hasExtra ? '重新提交' : '提交'
              }}
            </a-button>
            <a-button @click="$close($route.path)">关闭</a-button>
          </a-space>
        </div>
      </a-form>
    </div>
  </div>
</template>

<script>
import organization from "@/mixins/organization";
import FileUpload from "@/components/file-upload.vue";
import {add, resubmit, hasApprovableAssets} from "@/api/human-resources/leave";
import {getLeaveApplyInfo} from "@/api/human-resources/employee";
import {replaceUrl} from "@/api/approval";
import {mapState, mapGetters} from "vuex";
import moment from "moment";

export default {
  mixins: [organization],
  components: {
    FileUpload
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapGetters("auth", ["department"]),

    currentUser() {
      if (this.user && this.user.uuid) return this.user;
      try {
        return JSON.parse(window.localStorage.getItem("user") || "{}");
      } catch (e) {
        return {};
      }
    },

    currentDept() {
      const u = this.currentUser;
      if (u && u.employeeVo) return u.employeeVo;
      return this.department || {};
    },

    hasExtra() {
      console.log('this.extra===',this.extra && Object.keys(this.extra).length > 0)
      return this.extra && Object.keys(this.extra).length > 0;
    }
  },

  props: {
    extra: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      fileList: [],
      applicant: {}, // 申请人信息
      hasAssets: false // 是否有未移交的固定资产
    };
  },

  mounted() {
    this.fillCurrentUser();
    this.fillExtraData();
  },

  methods: {
    fillCurrentUser() {
      // 编辑模式：使用 extra 中的数据，不走自动获取
      if (this.hasExtra) {
        const extra = this.extra;
        this.applicant = {
          userId: extra.applicantId || '',
          name: extra.applicant || ''
        };
        this.$nextTick(() => {
          const setFields = () => {
            this.form.setFieldsValue({
              applyDeptId: extra.applyDeptId || undefined,
              position: extra.position || undefined,
              workStartDate: extra.workStartDate ? moment(extra.workStartDate) : undefined,
              contractStartDate: extra.contractStartDate ? moment(extra.contractStartDate) : undefined,
              contractEndDate: extra.contractEndDate ? moment(extra.contractEndDate) : undefined,
              entryDate: extra.entryDate ? moment(extra.entryDate) : undefined
            });
          };
          if (this.organizationList && this.organizationList.length > 0) {
            setFields();
          } else {
            const unwatch = this.$watch("organizationList", (list) => {
              if (list && list.length > 0) {
                setFields();
                unwatch();
              }
            });
          }
        });
        const userId = this.applicant.userId;
        if (userId) {
          this.checkAssets(userId);
        }
        return;
      }

      // 新增模式：自动获取当前用户信息
      const user = this.currentUser;
      const dept = this.currentDept;

      this.applicant = {
        userId: user.uuid || user.id,
        name: user.userName || user.name
      };

      if (dept && dept.deptId) {
        this.$nextTick(() => {
          const setFields = () => {
            this.form.setFieldsValue({
              applyDeptId: dept.deptId || undefined
            });
          };
          if (this.organizationList && this.organizationList.length > 0) {
            setFields();
          } else {
            const unwatch = this.$watch("organizationList", (list) => {
              if (list && list.length > 0) {
                setFields();
                unwatch();
              }
            });
          }
        });
      }

      const userId = user.uuid || user.id;
      if (userId) {
        this.fetchEmployeeInfo(userId);
        this.checkAssets(userId);
      }
    },

    fillExtraData() {
      if (!this.extra || Object.keys(this.extra).length === 0) return;
      const formData = {};
      if (this.extra.leaveDate) {
        formData.leaveDate = moment(this.extra.leaveDate);
      }
      if (this.extra.leaveReason) {
        formData.leaveReason = this.extra.leaveReason;
      }
      if (Object.keys(formData).length > 0) {
        this.$nextTick(() => {
          this.form.setFieldsValue(formData);
        });
      }
      if (this.extra.attachmentList && Array.isArray(this.extra.attachmentList)) {
        this.fileList = this.extra.attachmentList.filter(item => item && item.id);
      }
    },

    checkAssets(userId) {
      hasApprovableAssets(userId)
        .then(res => {
          this.hasAssets = Boolean(res)
        })
        .catch(err => {
          console.error('查询固定资产失败', err);
        });
    },

    fetchEmployeeInfo(userId) {
      getLeaveApplyInfo(userId)
          .then(res => {
            if (res) {
              // 将员工信息填充到表单
              const formData = {};

              // 岗位或职务
              if (res.position) {
                formData.position = res.position;
              }

              // 入职日期
              if (res.entryDate) {
                formData.entryDate = moment(res.entryDate);
              }

              // 参加工作时间
              if (res.workStartDate) {
                formData.workStartDate = moment(res.workStartDate);
              }

              // 合同开始时间
              if (res.contractStartDate) {
                formData.contractStartDate = moment(res.contractStartDate);
              }

              // 合同结束时间
              if (res.contractEndDate) {
                formData.contractEndDate = moment(res.contractEndDate);
              }

              // 填充表单
              this.$nextTick(() => {
                this.form.setFieldsValue(formData);
              });
            }
          })
          .catch(err => {
            console.error('获取员工信息失败', err);
          });
    },

    onDeptChange(deptId) {
      // 根据部门ID自动填充部门名称（备用，主要依赖 fillCurrentUser）
      const dept = this.organizationList.find(item => item.id === deptId);
      if (dept) {
        this.applyDeptName = dept.uniqueName;
      }
    },

    onFileUploaded(list) {
      // 处理文件上传成功
      if (this.fileList.length + list.length > 5) {
        this.$message.warning('最多上传5个文件');
        const remaining = 5 - this.fileList.length;
        this.fileList = [...this.fileList, ...list.slice(0, remaining)];
      } else {
        this.fileList = [...this.fileList, ...list];
      }
    },

    deleteFile(index) {
      // 删除文件
      this.fileList.splice(index, 1);
    },

    downloadTemplate() {
      // 调用 replaceUrl 接口获取模板下载链接
      const templateUrl = 'https://qiniu.njszy.com/工作交接清单.xlsx';
      replaceUrl({
        publicUrls: templateUrl
      }).then(res => {
        if (res) {
          // 使用转换后的URL下载
          window.open(res, '_blank');
        }
      }).catch(error => {
        console.error('获取模板下载链接失败', error);
        this.$message.error('模板下载失败，请稍后重试');
      });
    },

    handleSubmit(e) {
      e.preventDefault();

      // 校验附件必填
      if (this.fileList.length === 0) {
        this.$message.error('请上传附件！');
        return;
      }

      // 校验固定资产是否已移交
      if (this.hasAssets) {
        this.$message.error('您名下还有未移交的固定资产，请先完成资产移交后再提交。');
        return;
      }

      this.form.validateFields((err, values) => {
        if (err) {
          console.error('表单验证失败', err);
          this.$message.error('请检查表单是否填写完整！');
          return;
        }

        // 获取申请部门名称
        let applyDeptName = '';
        if (values.applyDeptId) {
          const dept = this.organizationList.find(item => item.id === values.applyDeptId);
          if (dept) {
            applyDeptName = dept.uniqueName;
          }
        }

        const data = {
          ...values,
          applicant: this.applicant.name || '',
          applicantId: this.applicant.userId || '',
          applyDept: applyDeptName,
          entryDate: values.entryDate ? values.entryDate.format('YYYY-MM-DD') : null,
          leaveDate: values.leaveDate ? values.leaveDate.format('YYYY-MM-DD') : null,
          workStartDate: values.workStartDate ? values.workStartDate.format('YYYY-MM-DD') : null,
          contractStartDate: values.contractStartDate ? values.contractStartDate.format('YYYY-MM-DD') : null,
          contractEndDate: values.contractEndDate ? values.contractEndDate.format('YYYY-MM-DD') : null,
          attachments: this.fileList.filter(f => f.id).map(f => f.id).join(','),
        };

        // 重新提交时添加id
        if (this.hasExtra && this.extra.id) {
          data.id = this.extra.id;
        }

        this.loading = true;
        const apiMethod = this.hasExtra ? resubmit : add;
        apiMethod(data)
            .then(() => {
              this.$message.success(this.hasExtra ? '重新提交成功' : '提交成功');
              this.$close(this.$route.path);
            })
            .catch(error => {
              console.error('提交失败', error);
              this.$message.error(error.message || '提交失败，请重试！');
            })
            .finally(() => {
              this.loading = false;
            });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  padding: 20px;
  background: #fff;
}

.center {
  margin-top: 20px;
  text-align: center;
}

// 确保所有表单控件可交互
/deep/ .ant-input,
/deep/ .ant-calendar-picker,
/deep/ .ant-select,
/deep/ .ant-input-number,
/deep/ .ant-checkbox-wrapper,
/deep/ .ant-radio-wrapper {
  pointer-events: auto !important;
}

// 确保日期选择器弹出层不被遮挡
/deep/ .ant-calendar-picker-container {
  z-index: 1050 !important;
}
</style>
